const data = {
  translation: {
    lbl_welcome: "Welcome to",
    lbl_hodo_community_events: "HODO Community Events",
    lbl_setup_sound_and_video:
      "Setting audio and screen device before participating.",
    lbl_join_room: "Join room",
    lbl_join_conference: "Join conference",
    lbl_enter_name: "Enter my name",
    lbl_on: "On",
    lbl_off: "Off",
    lbl_change_camera: "Toggle front or back Camera",
    lbl_add_virtual_background: "Add virtual background",
    lbl_vietnamese: "Vietnamese",
    lbl_english: "English",
    lbl_french: "French",
    lbl_setting_device: "Device settings",
    lbl_notification: "Notification",
    lbl_view_layout: "Layout view",
    lbl_audio_device: "Audio device",
    lbl_speaker: "Speaker",
    lbl_test: "Test",
    lbl_noise_suppression: "Noise suppression",
    lbl_participants: "Participants",
    lbl_the_leaver: "The leaver",
    lbl_new_message: "New message",
    lbl_hand_raiser: "Hand-raiser",
    lbl_error: "Error",
    lbl_active_speaker_mode: "Active speaker mode",
    lbl_arranging_active_speakers: "Arranging active speakers",
    lbl_audio_only_mode: "Audio-only mode",
    lbl_personal_video_mirror: "Mirror personal video",
    lbl_personal_video_hidden: "Hidden personal video",
    lbl_error_check_role: "Error checking user roles",
    lbl_meting: "Meeting",
    lbl_room_code_is_disabled: "Room code is disabled",
    lbl_room_code_does_not_exist: "Room code does not exist",
    lbl_endpoint_is_not_reachable: "Endpoint is not reachable",
    lbl_room_does_not_exist: "Room does not exist",
    lbl_accessing_disabled: "Accessing room using this link format is disabled",
    lbl_error_fetching_token: "Error fetching token",
    fm_toggle_interpretation: "Choose to listen to interpretation",
    lbl_other_options: "Another option",
    lbl_setting: "Setting",
    lbl_you: "You",
    lbl_have_a_nice_day: "Have a nice day",
    lbl_join_again: "You want to join again",
    lbl_click_here: "Click here",
    lbl_stream: "stream",
    lbl_room: "room",
    lbl_rename: "Rename",
    lbl_change_role: "Change role",
    lbl_change_my_role: "Change my role",
    lbl_mute_all: "Mute all",
    lbl_exit: "Exit",
    lbl_url_embed: "URL embed",
    lbl_cancel: "Cancel",
    lbl_change: "Change",
    lbl_update_embed: "Update embed",
    lbl_stop_embed: "Stop embed",
    lbl_embed_and_share: "Embed and share",
    lbl_change_multiple_role: "Change multiple role",
    lbl_select_role: "Select role",
    lbl_select_multiple_role: "Select multiple role",
    lbl_become_role: "Become role:",
    lbl_my_screen: "My screen",
    lbl_signal: "Poor signal",
    lbl_mute_mic: "You're muted",
    lbl_participants_1: "Participants",
    lbl_no_participants: "There are no participants",
    lbl_no_suitable_participants: "There are no suitable participants",
    lbl_input_search: "Input search information",
    lbl_all: "All",
    lbl_change_permissions: "Change permissions",
    lbl_remove_participants: "Remove participants",
    lbl_change_role_of: "Change role of",
    lbl_become: "become",
    lbl_submit_request_confirm: "Send confirmation request",
    lbl_pin: "Pin",
    lbl_unpin: "Unpin",
    lbl_outstanding_position_for_everyone: "Outstanding position for everyone",
    lbl_removed_from_prominent_position: "Removed from prominent position",
    lbl_connected_now: "You are now connected",
    lbl_open_chat: "Open chat",
    lbl_welcome_joined: "Welcome, you've joined",
    lbl_person_first: "You are the first person to join the room",
    lbl_sit_down: "Please sit back and relax until others join",
    lbl_select_maximum_resolution: "Select maximum resolution",
    lbl_currently_streaming: "Currently streaming:",
    lbl_low: "Low",
    lbl_high: "Medium",
    lbl_medium: "High",
    lbl_sharing_screen: "You are sharing your screen",
    lbl_stop_share: "Stop sharing your screen",

    msg_error_check_role:
      "An error occurred while checking your role. Please double check your role or contact Circle's Seed for more details.",
    msg_room_code_is_disabled:
      "Room code corresponding to this link is no more active.",
    msg_room_code_does_not_exist:
      "We could not find a room code corresponding to this link.",
    msg_room_does_not_exist:
      "We could not find a room corresponding to this link.",
    msg_accessing_disabled:
      "You can re-enable this from the developer section in Dashboard.",
    msg_error_fetching_token:
      "An error occurred while fetching the app token. Please look into logs for more details.",
    msg_embed:
      "Embed the url and share with everyone in the room. Make sure you're sharing the current tab when the prompt opens. Note that not all websites support embedding.",

    fm_toggle_sound: "{{status}} mic ({{key}} + d)",
    fm_toggle_video: "{{status}} video ({{key}} + e)",
    fm_toggle_background: "{{status}} virtual background",
    fm_gird_layout_view: "Grid in view({{count}})",
    fm_toggle_pip: "{{status}} picture-in-picture mode",
    fm_interpretation_end:
      "{{text1}} translation has ended. You are redirected to listen to {{text2}}",
    fm_interpretation_select: "You have chosen to listen to {{text}}",
    fm_you_have_left_cabin: "You have left the epidemic room",
    fm_not_connect_room: "Can't connect to {{name}}",
    fm_endpoint_is_not_reachable: "Endpoint is not reachable. {{desc}}",
    fm_you_out_room: "You have left the room {{name}}",
    fm_fullscreen: "{{action}} fullscreen",
    fm_open_chat: "{{action}} chat",
    fm_you_content: "You ({{content}})",
    fm_toggle_fullscreen: "{{text}} fullscreen",
    fm_toggle_sharescreen: "{{text}} screen sharing",
    fm_volume: "Volume {{number}}",
    fm_pin_screen: "{{action}} frame",
    fm_block_permission: "Permission {{device}} has been blocked",
    fm_access_permission: "Access to {{device}} is required. ",
    fm_accept_permission_system:
      "Enable {{device}} permissions from the system",
    fm_accept_permission_browser:
      "Enable {{device}} permissions from the address bar or browser settings",
    fm_hands_up: "{{name}} hands up",
    fm_hands_up_multiple:
      "{{name}} and {{number}} other person raised their hands",
    fm_joined: "{{name}} joined",
    fm_left: "{{name}} left",
    fm_left_multiple: "{{name}} and {{number}} other person left",
    fm_new_message: "New message from {{name}}",
    fm_new_message_multiple: "{{number}} new message",
    fm_offline:
      "You are now online, while we try to reconnect, please check your internet connection. {{message}}",

    fm_start: "Start",
    fm_stop: "Stop",
    lbl_no_msg: "No message",
    lbl_hands_up: "Hands up",
    lbl_hands_down: "Hands down",
    lbl_open: "Open",
    lbl_close: "Close",
    lbl_activate: "Activate",
    lbl_deactivate: "Deactivate",
    lbl_everyone: "Everyone",
    lbl_new_msgs: "New messages",
    lbl_find_participants: "Find participants",
    lbl_roles: "Roles",
    lbl_participant: "Participants",
    lbl_write_smt_here: "Write something here",
    lbl_toggle_all_remote_audio_devices: "Mute/Unmute remote audio devices",
    lbl_all_roles: "All roles",
    lbl_track_type: "Track type",
    lbl_track_source: "Track source",
    lbl_track_status: "Track status",
    lbl_mute: "Mute",
    lbl_unmute: "Request to unmute",
    lbl_apply: "Apply",
    lbl_all_sources: "All sources",
    lbl_all_devices: "All device types",
    lbl_strangers: "Stranger",
    lbl_pin_msg: "Pin message",

    obj_roles: {
      lbl_presenter: "Presenter",
      lbl_broadcaster: "Speaker",
      lbl_panelist: "Panelist",
      lbl_translator: "Interpreter",
      "lbl_e-v": "English - Vietnamese",
      "lbl_f-v": "French - Vietnamese",
      lbl_vietnamese: "Vietnamese",
      lbl_guest: "Guest",
      "lbl_guest-advanced": "Guest (Advanced)",
      lbl_viewer: "Viewer",
      "lbl_hls-viewer": "Viewer",
    },
    lbl_waiting_for_the_live_stream_to_start:
      "Waiting for the livestream to start",
    lbl_live_streaming: "Live Streaming",
    lbl_stream_management: "Manage Stream",
    lbl_stop_recording: "Stop Recording",
    lbl_are_you_sure_you_want_to_end_the_recording:
      "Are you sure you want to end the recording?",
    lbl_stop: "Stop",
    lbl_starting_recording: "Starting Recording",
    lbl_start_recording: "Start Recording",
    lbl_start: "Start",
    lbl_recording_already_running: "Recording already running",
    lbl_browser_message:
      'The browser wants us to get a confirmation for playing the Live HODO. Please click "play stream" to proceed.',
    lbl_select_quality: "Select Quality",
    lbl_auto: "Auto",
    lbl_play: "Play",
    lbl_pause: "Pause",
    lbl_the_conference_will_start_in: "The conference will start in",
    lbl_the_conference_will_begin_soon:
      "The conference will begin soon. \nPlease sit down, rest and relax in the waiting time.",
    lbl_the_conference_has_ended:
      "The conference has ended, please come back at another time. \nThank you!",
    lbl_you_can_connect_with_others: "You cannot connect with others.",
    lbl_you_are_connected_but_no_one_is_active_in_the_circle:
      "You're connected but no one is active in the circle.",
    lbl_curentky_there_is_no_one_else_in_the_room:
      "Currently, there is no one else in the room.",
    lbl_this_role_does_not_exist: "This role does not exist.",
    lbl_this_role_has_not_been_published: "This role has not been published.",
  },
};

export default data;
